import { Button } from '@talentmesh/ui/components/button';
import { TypographyP } from '@talentmesh/ui/components/typography';
import { useState } from 'react';
import EditBillingAddressDialog from './EditBillingAddressDialog';
import PaymentSection from './PaymentSection';
import BillingInfo from '@/Models/BillingInfo';
import UIStrings from '@/Utils/UIStrings';

interface BillingAddressProps {
    billingInfo: BillingInfo | undefined;
    setBillingInfo: React.Dispatch<React.SetStateAction<BillingInfo | undefined>>;
}

const BillingAddress = ({ billingInfo, setBillingInfo }: BillingAddressProps) => {
    const [open, setOpen] = useState(false);

    const handleDialogOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const editBillingAddressComponent = billingInfo ? (
        <div>
            <Button variant="outline" type="button" onClick={handleDialogOpen}>
                {UIStrings.Edit}
            </Button>
        </div>
    ) : null;

    return (
        <>
            <PaymentSection header={UIStrings.BillingAddress} actionComponent={editBillingAddressComponent}>
                {billingInfo ? (
                    <div className="flex flex-col">
                        <TypographyP className="text-base">{billingInfo.billingTo}</TypographyP>
                        <TypographyP className="text-base">{billingInfo.addressLine1}</TypographyP>
                        <TypographyP className="text-base">{billingInfo.addressLine2}</TypographyP>
                        <TypographyP className="text-base">
                            {billingInfo.city}, {billingInfo.state} {billingInfo.postalCode}
                        </TypographyP>
                        <TypographyP className="text-base">{billingInfo.country}</TypographyP>
                    </div>
                ) : (
                    <div>
                        <button
                            type="button"
                            onClick={handleDialogOpen}
                            className="text-primary hover:text-primary/80 text-base underline"
                        >
                            {UIStrings.AddBillingAddress}
                        </button>
                    </div>
                )}
            </PaymentSection>
            <EditBillingAddressDialog
                open={open}
                setBillingInfo={setBillingInfo}
                onClose={handleClose}
                billingInfo={billingInfo}
            />
        </>
    );
};

export default BillingAddress;
